import PropTypes from 'prop-types';
import React from 'react';
import { Button, Icon, Tooltip } from '@popmenu/common-ui';
import { FacebookIcon, GoogleIcon } from '@popmenu/web-icons';

import { useIntl } from '../../utils/withIntl';
import withSocialButton from '../../utils/withSocialButton';
import { classNames, withStyles } from '../../utils/withStyles';
import signInStyles from '../../assets/jss/shared/signInStyles';

const ICON_MAP = {
  facebook: FacebookIcon,
  google: GoogleIcon,
};

const SocialButton = ({
  'aria-label': ariaLabel = null,
  buttonProps = {},
  children = null,
  classes,
  customFollowPath,
  loading = false,
  openSocialLogin,
  preview,
  rounded = false,
  size = 'large',
  socialType,
  tooltip = undefined,
}) => {
  const t = useIntl();
  const { className: buttonPropsClassName, variant: buttonPropsVariant, ...otherButtonProps } = buttonProps ?? {};
  const variant = buttonPropsVariant ?? (rounded ? 'outlined' : 'contained');
  const baseClassName =
    buttonPropsClassName != null && buttonPropsClassName !== '' ?
      buttonPropsClassName :
      classNames(classes.socialButton, classes[`button-${socialType}`]);
  const buttonClassName = classNames(baseClassName, rounded && classes.roundedSocialButton);

  return (
    <Tooltip title={tooltip || undefined}>
      <span>
        <Button
          aria-label={ariaLabel}
          disableElevation
          fullWidth
          className={buttonClassName}
          disabled={loading}
          startIcon={(
            <Icon icon={ICON_MAP[socialType.split('_')[0]]} />
        )}
          onClick={() => {
            if (!loading && !preview) {
              if (customFollowPath) {
                window.open(customFollowPath, '_blank').focus();
              } else {
                openSocialLogin();
              }
            }
          }}
          size={size}
          variant={variant}
          {...otherButtonProps}
        >
          {children || t(`sessions.omniauth.${socialType}`)}
        </Button>
      </span>
    </Tooltip>
  );
};

SocialButton.propTypes = {
  'aria-label': PropTypes.string,
  buttonProps: PropTypes.object,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  openSocialLogin: PropTypes.func.isRequired,
  rounded: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  socialType: PropTypes.oneOf(['facebook_type', 'google_type', 'twitter_type']).isRequired,
  tooltip: PropTypes.string,
};

export default withStyles(signInStyles)(withSocialButton(SocialButton));
